import "./UserFeed.css";
import avatar from "../assets/images/use-app.png";

import loginImg from "../assets/images/logo.svg";
import { BiAddToQueue } from "react-icons/bi";
import { MdOutlineNotifications } from "react-icons/md";
import { IoSettingsOutline } from "react-icons/io5"
import { useState } from "react";
import { useNavigate } from "react-router-dom";

// Top + Footer Icons
import {
  FaSearch,
  FaHome,
  FaUserFriends,
  FaUserCircle,
  FaRegImage,
  FaCamera,
  FaLink,
  FaMicrophone,
  FaListUl,
  FaMapMarkerAlt,

} from "react-icons/fa";



const UserFeed = () => {
  const [showSettings, setShowSettings] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    navigate("/login"); // redirect to login
      };

  return (
    <div className="feed">

      {/* ===== Top Header ===== */}
      <div className="top-header">
        <span className="brand">
          <img src={loginImg} alt="Login" className="login-image" />
        </span>

        <div className="top-actions">
          {/* Notification */}
          <button
            className="icon-btn"
            onClick={() => {
              setShowNotifications(!showNotifications);
              setShowSettings(false);
            }}
          >
            <MdOutlineNotifications />
          </button>

          {/* Settings */}
          <button
            className="icon-btn"
            onClick={() => {
              setShowSettings(!showSettings);
              setShowNotifications(false);
            }}
          >
            <IoSettingsOutline />
          </button>
        </div>

        {/* ===== Notification Dropdown ===== */}
        {showNotifications && (
          <div className="dropdown notification-dropdown">
            <p className="dropdown-title">Notifications</p>
            <ul>
              <li>🔔 New follower joined</li>
              <li>❤️ Someone liked your post</li>
              <li>💬 New comment on your post</li>
            </ul>
          </div>
        )}

        {/* ===== Settings Dropdown ===== */}
        {showSettings && (
          <div className="dropdown settings-dropdown">
            <button onClick={handleLogout}>Logout</button>
          </div>
        )}
      </div>

      {/* ===== Profile Card ===== */ }
  <div className="profile-card">
    <div className="post-box">
      <div className="post-header">
        <img src={avatar} alt="User" className="avatar" />

        <div className="post-input-area">
          <h4>
            Jhon <span>Thomar</span>
          </h4>
          <input type="text" placeholder="What’s new?" />
        </div>
      </div>

      <div className="post-input-actions">
        <FaRegImage />
        <FaCamera />
        <FaLink />
        <FaMicrophone />
        <FaListUl />
        <FaMapMarkerAlt />
      </div>
    </div>

    <div className="stats-row">
      <div>
        <strong>31</strong>
        <span>Post</span>
      </div>
      <div>
        <strong>961</strong>
        <span>Followers</span>
      </div>
      <div>
        <strong>142</strong>
        <span>Following</span>
      </div>
    </div>
  </div>

  {/* ===== Post Card ===== */ }
  <div className="post-card">
    <div className="post-head">
      <img src={avatar} alt="user" />
      <div>
        <h4>Andrew Wade</h4>
        <span>31 Post • 1m</span>
      </div>
    </div>

    <p className="post-text">
      This morning is fun. Playing golf and we make some challenge.
      Not winning today, but not bad 😄
    </p>

    <div className="post-meta">
      <h5>Meadow Springs Golf And Country Club</h5>
      <span>December 27, 2025</span>
    </div>

    <div className="post-footer-actions">
      <span>❤️ Like</span>
      <span>💬 Comment</span>
      <span>↗ Share</span>
    </div>
  </div>

  

  {/* ===== Bottom Footer Navigation ===== */ }
  <div className="bottom-footer">
    <button className="footer-item active">
      <FaHome />
      <span>Home</span>
    </button>

    <button className="footer-item">
      <FaSearch />
      <span>Search</span>
    </button>

    <button className="footer-item create-post">
      <BiAddToQueue />
    </button>

    <button className="footer-item">
      <FaUserFriends />
      <span>Network</span>
    </button>

    <button className="footer-item">
      <FaUserCircle />
      <span>Profile</span>
    </button>
  </div>

    </div >
  );
};

export default UserFeed;
